<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<!--<h1>Upload Images</h1>
<div class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <p-fileUpload name="files" [url]="getUploadUrl()" (onUpload)="onUpload($event)" (onBeforeUpload)="onBeforeUpload($event)" multiple="multiple"
      accept=".jpg,.jpeg,.gif" maxFileSize="31457280">
      <ng-template pTemplate="content">
        <ul *ngIf="uploadedFiles.length">
          <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes
          </li>
        </ul>
      </ng-template>
    </p-fileUpload>
  </span>
</div>-->

<h1>Upload Media</h1>
<p-fileUpload
  name="files[]"
  [customUpload]="true"
  (uploadHandler)="myUploader($event)"
  multiple="multiple"
  accept="image/*,video/*"
  [disabled]="formLoading"
  >
  <ng-template pTemplate="content">
    @if (uploadedFiles.length) {
      <ul>
        @for (file of uploadedFiles; track file) {
          <li>
            {{ file.name }} - {{ file.size }} bytes
          </li>
        }
      </ul>
    }
  </ng-template>
</p-fileUpload>


<br><br>
<h1>Sort Media</h1>
<!-- Single flat cdkDropList containing all items.
     A single list gives CDK one flat index space — moveItemInArray(images, prev, curr)
     always maps to the item the user visually dropped onto, regardless of which row
     it lives in. The previous multi-list (one cdkDropList per item + cdkDropListGroup)
     caused wrong-row and wrong-position drops because CDK's bounding-box hit-detection
     fails when flex-wrap shifts items after the placeholder is inserted.

     NOTE: cdkDropListOrientation is intentionally NOT set to "mixed" here.
     "mixed" uses MixedSortStrategy which moves DOM nodes during drag, causing the
     flex container to reflow. After the first cross-row swap the target items shift
     position and CDK's elementFromPoint misses them — the drag freezes after one row.
     With default "vertical" orientation CDK uses CSS transforms (no reflow). We
     compute the correct drop index in onDrop() using 2D bounding-box math instead. -->
<div #dropContainer class="example-container"
     cdkDropList
     [cdkDropListData]="images"
     (cdkDropListDropped)="onDrop($event)">
  @for (image of images; track image.pictureId; let i = $index) {
    <div cdkDrag [cdkDragData]="image"
      class="example-drop-item example-box position-relative">
      <!-- drag handle so the click area for preview is separate from drag -->
      <div cdkDragHandle class="drag-handle" title="Drag to reorder">
        <i class="pi pi-bars"></i>
      </div>
      <!-- IMAGE DISPLAY -->
      @if (isImage(image.url)) {
        <img
          [src]="image.url"
          alt="{{image.caption}}"
          width="150"
          height="100"
          (click)="openPreview(i)"
          style="cursor: pointer; object-fit: cover; display: block;"
          />
      }
      <!-- VIDEO DISPLAY -->
      @if (isVideo(image.url)) {
        <div
          style="position: relative; width: 150px; height: 100px; cursor: pointer;"
          (click)="onVideoContainerClick($event, i)">
          <video
            width="150"
            height="100"
            controls
            (click)="onVideoClick($event, i)"
            #videoElement
            >
            <source [src]="getVideoUrl(image.fileName)" [type]="getMimeType(image.url)" />
          </video>
        </div>
      }
      <div class="w-100 content-bg">
        <p class="text-center mb-0">{{image.pictureId}}</p>
        <p class="text-center mb-0">{{getDescribeTypeName(image.describesType)}}</p>
        @if (image.slPictureId) {
          <p class="text-center mb-0">SL ID {{image.slPictureId}}</p>
        }
      </div>
    </div>
  }
</div>


<br><br>
<h1>Edit Media</h1>
<div class="media-table-wrapper">
<p-table #pt [value]="pictures" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="pictureId" selectionMode="single"
  [(selection)]="image" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="200"
  [rowsPerPageOptions]="[200,500,1000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
  <ng-template pTemplate="caption">
    <div  class="d-block text-end">
      <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
      (click)="unSelectAllPictures()">Unselect All</button>
      <button pButton pRipple class="p-button-text" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
      (click)="selectAllPictures()">Select All</button>
      @if (forDeletePictures.length > 0) {
        <span>
          <!--Delete Checked-->
          <button pButton pRipple class="p-button" style="background-color:red;padding: 0.643rem 0.75rem !important;"
          (click)="deleteMultiplePictures()">Delete Checked</button>
        </span>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [ngStyle]="{'width': '50px'}"></th>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th class="media-actions-cell"></th>
    </tr>
    <tr>
      <th [ngStyle]="{'width': '50px'}"></th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-dropdown [style]="{'width':'50px','min-width':'90%'}" [options]="describeTypes" appendTo="body"
          (onChange)="pt.filter($event.value, 'describesType', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="code"
          [value]="pt.filters['describesType'] ? pt.filters['describesType'].code : ''">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'caption', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text"
        (input)="pt.filter($event.target.value, 'propertyCode', 'in')"
      [value]="pt.filters['propertyCode'] ? pt.filters['propertyCode'].value : ''"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" style="text-align: center;" pInputText type="text"
      (input)="pt.filter($event.target.value, 'developmentVO.addressDevelopmentName', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'sortOrder', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'slPictureId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'pictureId', 'in')"></th>
      <th class="media-actions-cell"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-image>
    <tr>
      <td>
        @if (isImage(image.url)) {
          <p-image src="{{image.url}}" alt="{{image.caption}}" width="400" preview="true"></p-image>
        }
        @if (isVideo(image.url)) {
          <video
            width="400"
            height="225"
            controls
            style="cursor: pointer;"
            >
            <source [src]="getVideoUrl(image.fileName)" [type]="getMimeType(image.url)" />
          </video>
        }
      </td>
      <td>
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [options]="describeTypes" [(ngModel)]="image.describesType" id="describesType"
            (onChange)="formUpdate(image)" optionLabel="name" optionValue="code" [filter]="true"
            filterBy="name" [showClear]="false" appendTo="body" [style]="{'min-width':'200px'}">
          </p-dropdown>
        </span>
      </td>
      <td>
        <span class="p-float-label w-100 mb-3">
          <textarea #captionarea [(ngModel)]="image.caption" [value]="image.caption" id="caption" [rows]="6"
            style="min-width:300px"
            (keydown)="cl6.style.visibility = 'visible';captionarea.style.backgroundColor = '#FFCCCB';"
          pInputTextarea></textarea>

          <a #cl6
            (click)="formUpdate(image);captionarea.style.backgroundColor = 'transparent';cl6.style.visibility = 'hidden';"
            style="margin-left:2px;visibility:hidden;color:red"><i style="font-size:200%" class="pi pi-save"
          aria-hidden="true"></i></a>
        </span>
      </td>
      <td>
        {{image.propertyCode}}

      </td>
      <td>
        {{image.adrDevelopmentName}}
      </td>
      <td>
        {{image.sortOrder}}
      </td>
      <td>
        {{image.slPictureId}}
      </td>
      <td>
        {{image.pictureId}}
      </td>
      <td class="media-actions-cell">
        <a>
          <i class="pi pi-pencil" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(image)"></i>
        </a>
        <a (click)="onDelete(image)"><i class="pi pi-times" aria-hidden="true"
        style="color:red; font-size:110%; padding-right:20px;"></i></a>
        <p-checkbox [(ngModel)]="image.checked" [ngModelOptions]="{standalone: true}" [value]="image.checked" (click)="addIntoCheckedList(image)" [binary]="true"></p-checkbox>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>

<!-- Custom Image/Video Preview Dialog -->
<p-dialog [(visible)]="previewVisible" [modal]="true" [style]="{width: '600px'}" [closable]="true" [dismissableMask]="true">
  <ng-template pTemplate="header">
    {{ isVideo(images[currentIndex]?.url) ? 'Video Preview' : 'Image Preview' }}
  </ng-template>

  <div class="text-center">
    <!-- Image Display -->
    @if (isImage(images[currentIndex]?.url)) {
      <img
        [src]="images[currentIndex]?.url"
        [alt]="images[currentIndex]?.caption"
        style="max-width: 100%; max-height: 400px;"
        />
    }

    <!-- Video Display -->
    @if (isVideo(images[currentIndex]?.url)) {
      <video
        [src]="getVideoUrl(images[currentIndex]?.fileName)"
        controls
        style="max-width: 100%; max-height: 400px;"
        >
        <source [src]="images[currentIndex]?.url" [type]="getMimeType(images[currentIndex]?.url)" />
        Your browser does not support the video tag.
      </video>
    }
  </div>

  <div class="text-center mt-3">
    <button pButton label="Previous" icon="pi pi-chevron-left" class="p-button-sm" (click)="prevImage()" [disabled]="currentIndex === 0"></button> &nbsp;&nbsp;&nbsp;&nbsp;
    <button pButton label="Next" icon="pi pi-chevron-right" class="p-button-sm" (click)="nextImage()" [disabled]="currentIndex === images.length - 1"></button>
  </div>
</p-dialog>